export default "__VITE_ASSET__Ca$5jb_p__"